/**
 * 2026-10-28 (owner) · "Show / hide fields", from the floating toolbar: switch off the optional parts of a
 * step this viewer does not use. All on by default; off hides it on every step (fieldPrefs.js).
 */
import React from "react";
import { Button, Modal, Switch } from "antd";
import {
  Activity, Camera, Gauge, GitBranch, Layers, LayoutList, ListChecks, MapPin, PenLine, Settings2,
  TextCursorInput, Timer, UserCheck, UserRound, Wrench,
} from "lucide-react";

import { FIELD_GROUPS, setFieldShown, showAllFields, useFieldPrefs } from "./fieldPrefs";

// 2026-10-28 (owner) · each switch carries the mark (and colour) its tag or field has on the page, so a
// row reads as the thing it hides.
const GROUP_ICON = { "Process hierarchy": Layers, "Step cards": LayoutList, "Config data": Settings2 };
const FIELD_ICON = {
  "left.continuous": [Activity, "#0d9488"],
  "card.place": [MapPin, "#e11d48"], "card.equipment": [Wrench, "#ea580c"],
  "card.performer": [UserRound, "#2563eb"], "card.signer": [UserCheck, "#16a34a"],
  "panel.duration": [Timer, "#7e22ce"], "panel.depends": [GitBranch, "#475569"],
  "panel.equipment": [Wrench, "#ea580c"], "panel.records": [PenLine, "#57534e"],
  "panel.checklist": [ListChecks, "#0f766e"], "panel.parameter": [Gauge, "#1d4ed8"],
  "panel.fields": [TextCursorInput, "#4338ca"], "panel.attachment": [Camera, "#0369a1"],
};

export default function FieldsDialog({ open, onClose }) {
  const { shown, hidden } = useFieldPrefs();
  return (
    <Modal open={open} onCancel={onClose} title="Show / hide fields" width={480} rootClassName="dz"
           footer={[
             <Button key="all" onClick={showAllFields} disabled={!hidden.length}>Show all</Button>,
             <Button key="done" type="primary" onClick={onClose}>Done</Button>,
           ]}>
      <p className="dz-fieldsnote">Only for you, on this browser. Required fields always stay.</p>
      {FIELD_GROUPS.map((g) => (
        <section key={g.title} className="dz-fieldsgroup">
          <h4>{GROUP_ICON[g.title] ? React.createElement(GROUP_ICON[g.title], { size: 14, "aria-hidden": true }) : null}{g.title}</h4>
          <p className="hint">{g.hint}</p>
          {g.fields.map((f) => (
            <label key={f.key} className="dz-fieldsrow">
              <span className="nm">
                {FIELD_ICON[f.key] ? React.createElement(FIELD_ICON[f.key][0], { size: 15, color: FIELD_ICON[f.key][1], "aria-hidden": true }) : null}
                {f.label}
              </span>
              <Switch size="small" checked={shown(f.key)} onChange={(v) => setFieldShown(f.key, v)}
                      aria-label={`Show ${f.label}`} />
            </label>
          ))}
        </section>
      ))}
    </Modal>
  );
}
